export const NOVEL_GENRES = [
  { id: 'Mystery', label: 'Mystery' },
  { id: 'Horror', label: 'Horror' },
  { id: 'Suspense', label: 'Suspense' },
  { id: 'Romance', label: 'Romance' },
  { id: 'Fantasy', label: 'Fantasy' },
  { id: 'Sci-Fi', label: 'Sci-Fi' },
] as const;

export const NOVEL_TONES = [
  { id: 'Dark', label: 'Dark' },
  { id: 'Mysterious', label: 'Mysterious' },
  { id: 'Emotional', label: 'Emotional' },
  { id: 'Comical', label: 'Comical' },
  { id: 'Serious', label: 'Serious' },
] as const;

export const NOVEL_SETTINGS = [
  { id: 'School', label: 'School', background: 'school_night' },
  { id: 'Station', label: 'Station', background: 'station_night' },
  { id: 'Hospital', label: 'Hospital', background: 'hospital_night' },
  { id: 'Hotel', label: 'Hotel', background: 'hotel' },
  { id: 'Town', label: 'Town', background: 'town' },
  { id: 'Isolated House', label: 'Isolated House', background: 'isolated_house' },
] as const;

export const NOVEL_PLAY_TIMES = [{ id: 'Short', label: 'Short（5〜10分）' }] as const;

export type NovelGenreId = (typeof NOVEL_GENRES)[number]['id'];
export type NovelToneId = (typeof NOVEL_TONES)[number]['id'];
export type NovelSettingId = (typeof NOVEL_SETTINGS)[number]['id'];
